import React from "react";
import styled from "styled-components";
import celebrateIcon from "../../../../../assets/WebsiteBuilder/celebrateIcon.svg";
import copyIcon from "../../../../../assets/WebsiteBuilder/copyIcon.svg";
import colorIcon from "../../../../../assets/WebsiteBuilder/colorIcon.svg";
import settingIcon from "../../../../../assets/WebsiteBuilder/settingIcon.svg";
import loopIcon from "../../../../../assets/WebsiteBuilder/loopIcon.svg";
import eyeIcon from "../../../../../assets/WebsiteBuilder/eyeIcon.svg";
import Toast from "components/molecules/Toast";

const StyledTemplateCreatedModal = styled.div`
    width: 100%;
    @media (min-width: 900px) {
        padding: 0 100px;
    }
    .head {
        text-align: center;
        margin-bottom: 40px;
        @media (min-width: 576px) {
            display: flex;
            justify-content: center;
            align-items: flex-start;
            gap: 10px;
            margin-bottom: 80px;
        }
        img {
            margin-bottom: 10px;
        }
        .head-title {
            color: var(--text-color);
            font-size: 28px;
            line-height: 32px;
            font-weight: 500;
            margin-bottom: 12px;
            @media (min-width: 576px) {
                font-size: 40px;
                line-height: 44px;
            }
        }
        .head-desc {
            color: var(--gray);
            font-size: 18px;
            line-height: 22px;
            font-weight: 300;
        }
    }
    .label {
        color: var(--text-color);
        font-size: 20px;
        line-height: 24px;
        font-weight: 400;
        margin-bottom: 15px;
        @media (min-width: 576px) {
            font-size: 24px;
            line-height: 28px;
        }
    }
    .url-wrap {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        gap: 16px;
        padding: 16px 20px;
        border-radius: 15px;
        background: rgba(34, 181, 115, 0.15);
        margin-bottom: 54px;
        @media (min-width: 576px) {
            flex-direction: row;
            align-items: center;
        }
        .url-title {
            color: var(--gray);
            font-size: 18px;
            line-height: 22px;
            font-weight: 400;
            margin-bottom: 10px;
        }
        .url {
            color: var(--text-color);
            font-size: 20px;
            line-height: 24px;
            font-weight: 400;
        }
        .copyBtn {
            width: max-content;
            display: flex;
            align-items: center;
            gap: 10px;
            color: var(--text-color);
            background-color: var(--white);
            border-radius: 5px;
            padding: 7px 10px;
            cursor: pointer;
            font-size: 16px;
            line-height: 20px;
            font-weight: 400;
            border: none;
            outline: none;
        }
    }
    .management-wrap {
        list-style: none;
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 10px;
        @media (min-width: 576px) {
            grid-template-columns: repeat(2, 1fr);
            gap: 20px 15px;
        }
        .management {
            padding: 15px;
            border-radius: 15px;
            border: 1px solid rgba(233, 233, 233, 1);
            background-color: var(--white);
            text-align: center;
            cursor: pointer;
            @media (min-width: 576px) {
                padding: 26px;
            }
            .management-title {
                color: var(--text-color);
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 10px;
                font-size: 18px;
                line-height: 22px;
                font-weight: 400;
                margin-bottom: 10px;
            }
            .management-desc {
                color: var(--gray);
                font-size: 14px;
                line-height: 18px;
                font-weight: 300;
            }
        }
    }
`;

const TemplateCreatedModal = () => {
    const copyText = () => {
        const text = document.getElementById("url").innerText;
        navigator.clipboard
            .writeText(text)
            .then(() => {
                Toast({
                    message: "URL copied to clipboard!",
                    type: "success",
                });
            })
            .catch(err => {
                console.error("Failed to copy url: ", err);
            });
    };
    return (
        <StyledTemplateCreatedModal>
            <div className="head">
                <img src={celebrateIcon} alt="celebrateIcon" />
                <div>
                    <h2 className="head-title">Website Created Successfully!</h2>
                    <span className="head-desc">Your restaurant website is now live and ready to receive orders</span>
                </div>
            </div>
            <h2 className="label">Your Website URL</h2>
            <div className="url-wrap">
                <div>
                    <h2 className="url-title">Website URL</h2>
                    <span className="url" id="url">
                        ihopCanada.flowdish.com
                    </span>
                </div>
                <button className="copyBtn" onClick={() => copyText()}>
                    <img src={copyIcon} alt="copyIcon" />
                    Copy
                </button>
            </div>
            <h2 className="label">Website Management</h2>
            <ul className="management-wrap">
                <li className="management">
                    <h2 className="management-title">
                        <img src={colorIcon} alt="colorIcon" />
                        Change Template
                    </h2>
                    <span className="management-desc">Switch to a different design</span>
                </li>
                <li className="management">
                    <h2 className="management-title">
                        <img src={settingIcon} alt="settingIcon" />
                        Edit Information
                    </h2>
                    <span className="management-desc">Update restaurant details</span>
                </li>
                <li className="management">
                    <h2 className="management-title">
                        <img src={loopIcon} alt="loopIcon" />
                        Sync Menu
                    </h2>
                    <span className="management-desc">Auto-update menu items</span>
                </li>
                <li className="management">
                    <h2 className="management-title">
                        <img src={eyeIcon} alt="eyeIcon" />
                        Preview Website
                    </h2>
                    <span className="management-desc">View your live website</span>
                </li>
            </ul>
        </StyledTemplateCreatedModal>
    );
};

export default TemplateCreatedModal;
